import createReducer from 'utils/createReducer';
import { getTenantPostLoginConfig } from 'tenant/teanantPostLoginConfig';

// Initial State
const INIT_STATE = {
  ...getTenantPostLoginConfig(),
};

// Actions
const SET_CLIENT_CONFIG = 'client-config/SET_CLIENT_CONFIG';

// Reducers
export default createReducer(INIT_STATE, {
  [SET_CLIENT_CONFIG](state, client_config) {
    return {
      ...state,
      ...client_config,
    };
  },
});

// Action creators
export const setClientConfig = ({ client_config }) => {
  return {
    type: SET_CLIENT_CONFIG,
    payload: client_config,
  };
};
